<script>
import HomeServiceGift from "./HomeServiceGift.vue";

export default {
    components: {HomeServiceGift},
    props: {
        box: {
            type: String,
            default: 'list'
        },
        gifts: {
            type: Array,
            required: false
        }
    },
    computed: {
        isMobile() {
            return window.innerWidth <= 768;
        }
    },
}
</script>

<template>
    <div class="home-service-pack">
        <svg class="home-service-pack__icon" xmlns="http://www.w3.org/2000/svg" width="51" height="50"><g fill="none" fill-rule="evenodd" transform="translate(1.5 1)"><circle cx="24" cy="24" r="24" stroke="#FF6734" stroke-width="2"/><path fill="#FF6734" d="M36.313 23.613h-10.97v-3.327h10.969v3.327ZM25.343 35.26h9.282v-9.982h-9.281v9.982Zm2.819-21.102c.685-.677 1.873-.676 2.556 0a1.796 1.796 0 0 1 0 2.549c-.727.722-2.953 1.916-4.119 1.916-.241 0-.312-.053-.314-.055-.391-.4.74-3.282 1.877-4.41Zm-4.506 9.456H12.688v-3.327h10.968v3.327ZM14.375 35.26h9.281v-9.982h-9.281v9.982Zm3.907-21.102c.342-.34.796-.526 1.279-.526.48 0 .935.186 1.277.526 1.137 1.128 2.268 4.01 1.875 4.41 0 0-.07.055-.312.055-1.166 0-3.392-1.194-4.12-1.916a1.796 1.796 0 0 1 0-2.55Zm18.03 4.465h-5.339a6.54 6.54 0 0 0 .942-.743 3.446 3.446 0 0 0 0-4.895c-1.321-1.311-3.627-1.313-4.95 0-.73.724-2.673 3.67-2.404 5.638h-.122c.267-1.968-1.674-4.914-2.404-5.638-1.323-1.313-3.629-1.311-4.95 0a3.447 3.447 0 0 0-.002 4.895c.232.23.56.485.944.743h-5.34c-.93 0-1.687.747-1.687 1.664v4.16c0 .458.378.831.844.831h.844v9.982c0 .917.757 1.664 1.687 1.664h20.25c.93 0 1.688-.747 1.688-1.664v-9.982h.843a.838.838 0 0 0 .844-.832v-4.16c0-.916-.758-1.663-1.688-1.663Z"/></g></svg>
        <div class="home-service-pack__left">
            <h3 v-if="isMobile">Choisissez <br> votre cadeau</h3>
            <h3 v-else>Choisissez votre cadeau</h3>
            <p><strong>Accédez à un catalogue complet de cadeaux.</strong></p>
            <p>Le consommateur devrait toujours avoir le choix. C’est pourquoi, Testachats vous propose de choisir parmi un catalogue de cadeaux variés :</p>
        </div>
        <div class="home-service-pack__right">
            <HomeServiceGift :gifts="gifts"></HomeServiceGift>
        </div>
    </div>
</template>

<style scoped>

</style>
